import { Suffix } from '../_common/style';
import NumericalInputField, { NumericalInputFieldProps } from '.';

const PercentageInputField = (props: NumericalInputFieldProps) => (
  <NumericalInputField {...props} after={<Suffix>%</Suffix>} isDecimalValid={true} />
);

export default PercentageInputField;
